module.exports = __webpack_public_path__ + "img/backyard-bushes.6813804c.webp";